import api from "api";
import { useQuery } from "react-query";
import { useId } from "utils/hooks";
import { queryKeys } from "utils/misc";

export const usePhysicians = () => {
  const id = useId();
  const key = queryKeys.physicians(id);
  // @ts-ignore
  return useQuery(key, () => api.parse("GET /patients/{patient_id}/physicians", [id]));
};
